import { useNavigate } from "react-router-dom";

export default function BackLink() {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(-1)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && navigate(-1)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        cursor: "pointer",
        userSelect: "none",
        fontWeight: 600,
      }}
      aria-label="Go back"
    >
      <img src="/arrow-narrow-left.svg" alt="" aria-hidden="true" />
      <span>Back</span>
    </div>
  );
}
